import React from "react";
import { Card, Button } from "react-bootstrap";

const MeetingCard = ({ session, meta, renderPrereads, formatSessionTime, decodeGoogleRedirect, handleVideoClick }) => {
  const userTz = localStorage.getItem("userTimezone") || "Asia/Kolkata";
  const { formattedDate, formattedRange } = formatSessionTime(
    session.Date,
    session.Time,
    userTz
  );

  return (
    <Card className="mb-3">
      <Card.Body>
        <Card.Title>{session.Class}</Card.Title>
        <Card.Text>
          <strong>Date:</strong> {formattedDate} | <strong>Time:</strong> {formattedRange}
        </Card.Text>
        <Card.Text>
          <strong>Faculty:</strong> {session.Faculty}
          {meta.email && <><br /><strong>Email:</strong> {meta.email}</>}
          {meta.phone && <><br /><strong>Phone:</strong> {meta.phone}</>}
        </Card.Text>
        {renderPrereads(session)}
        <a
          href={decodeGoogleRedirect(session["Meeting Link"])}
          target="_blank"
          rel="noreferrer"
          className="btn btn-success me-2"
        >
          Join Zoom
        </a>
        {session.RecordingLink && (
          <Button variant="primary" onClick={() => handleVideoClick(session.RecordingLink)}>
            Watch Recording
          </Button>
        )}
      </Card.Body>
    </Card>
  );
};

export default MeetingCard;
